import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes'
import { setupRouterGuards } from './guards'
import { appConfig } from '@/config/environment'

const router = createRouter({
  history: createWebHistory(appConfig.routerBase),
  routes
})

setupRouterGuards(router)

export default router
